import { Answer } from 'src/models/Answers/AnswerModel';
import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

const currentAnswerResource = createDocumentResource<Answer>({
  name: 'currentAnswer',
  endpoint: 'v1/orgs/:orgId/snippets/:id',
  observerCreator: emptyObserverCreator,
});

export default currentAnswerResource;
